// extracted by mini-css-extract-plugin
module.exports = {"AverageSwitch":"style_AverageSwitch__38cHW","radio":"style_radio__3ApSY"};